module.exports = __webpack_public_path__ + "img/tcf_7.be522ad7.png";